export enum Brands {
    None,
    SpeedyCash,
    TitleMax,
    AvioCredit,
    CashCentral
}

export function parseBrand(value: string | undefined) {
    const brandName = (value ?? '').replace(/^\//g, '').split('-')[0].toLowerCase();
    switch (brandName) {
        case 'speedycash':
            return Brands.SpeedyCash;
        case 'titlemax':
            return Brands.TitleMax;
        case 'aviocredit':
            return Brands.AvioCredit;
        case 'cashcentral':
            return Brands.CashCentral;
        default:
            return undefined;
    }
}